export const MAX_PINNED_PROMPTS = 'Max number of prompts already pinned in this territory';
